export default __webpack_public_path__ + "static/SoFi-12e7119cdf4eafcc5a1c0038d4dc2bca.png";